/* tslint:disable */

/**
 */
export class ProdcharColor {
    ID_COLOR?: number;
    ID_PROD?: number;
    ID_PRODCHAR_COLORS?: number;
    LAYER_ORDER?: number;
    CODE_HEXA?: string;
    COLOR_NAME?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/prodchar-color.ts